import {
  PaymentRecord,
} from '@dapi/sdk';
import {
  createAmount,
} from '@dapi/sdk/spec';

export const paymentRecord1Adt1InfService1: PaymentRecord = {
  id: 'FPT21',
  flightIds: ['ST2'],
  paymentTransactions: [
    {
      paymentMethod: { paymentType: 'AlternativePaymentMethod'},
      amount: createAmount({
        template: {
          value: 1000,
          currencyCode: 'PHP'
        }
      }),
      authorization: {approvalCode: '831000'}
    }
  ],
  serviceItemIds: ['TSM16']
};

export const paymentRecordService1: PaymentRecord = {
  id: 'FPT40',
  paymentTransactions: [
    {
      paymentMethod: { paymentType: 'CustomPayment' },
      amount: createAmount({
        template: {
          value: 1000,
          currencyCode: 'EUR'
        }
      }),
      authorization: { approvalCode: 'APS1OK' }
    }
  ],
  serviceItemIds: ['TSM40']
};

export const paymentRecordService2: PaymentRecord = {
  ...paymentRecordService1,
  id: 'FPT43',
  serviceItemIds: ['TSM43']
};

export const paymentRecordService3: PaymentRecord = {
  ...paymentRecordService1,
  id: 'FPT46',
  serviceItemIds: ['TSM46']
};

export const paymentRecordService4: PaymentRecord = {
  ...paymentRecordService1,
  id: 'FPT49',
  serviceItemIds: ['TSM49']
};

export const paymentRecord1ADT1B15Service1: PaymentRecord = {
  id: 'FPT24',
  paymentTransactions: [
    {
      paymentMethod: { paymentType: 'CustomPayment' },
      amount: createAmount({
        template: {
          value: 4500,
          currencyCode: 'EUR'
        }
      }),
      authorization: { approvalCode: 'APS1OK' }
    }
  ],
  serviceItemIds: ['TSM24']
};

export const paymentRecord1ADT1B15Service2: PaymentRecord = {
  ...paymentRecord1ADT1B15Service1,
  id: 'FPT27',
  serviceItemIds: ['TSM27']
};

export const paymentRecord1ADT1B15Service3: PaymentRecord = {
  ...paymentRecord1ADT1B15Service1,
  id: 'FPT30',
  serviceItemIds: ['TSM30']
};

export const paymentRecord1ADT1B15Service4: PaymentRecord = {
  ...paymentRecord1ADT1B15Service1,
  id: 'FPT33',
  serviceItemIds: ['TSM33']
};

export const paymentRecord1ADT1B15Service5: PaymentRecord = {
  id: "FPT40",
  paymentTransactions: [
    {
      paymentMethod: {
        paymentType: "CustomPayment"
      },
      amount: createAmount({
        template: {
          value: 4500,
          currencyCode: 'EUR'
        }
      }),
      authorization: {
        approvalCode: "APS1OK"
      }
    }
  ],
  travelerIds: [
    "TRAVELER-0-MOCK"
  ],
  flightIds: [
    "ST2"
  ]
};

export const paymentRecord1ADT1B15Service6: PaymentRecord = {
  ...paymentRecord1ADT1B15Service5,
  id: "FPT43",
  travelerIds: [
    "TRAVELER-1-MOCK"
  ],
}

export const paymentRecord1Adt1SenoirService1: PaymentRecord = {
  id: 'FPT18',
  flightIds: ['ST3'],
  paymentTransactions: [
    {
      paymentMethod: { paymentType: 'AlternativePaymentMethod'},
      amount: createAmount({
        template: {
          value: 1000,
          currencyCode: 'Eur'
        }
      }),
      authorization: {approvalCode: '831000'}
    }
  ],
  serviceItemIds: ['TSM18']
};

export const paymentRecord1Adt1SenoirService2: PaymentRecord = {
  ...paymentRecord1Adt1SenoirService1,
  id: 'FPT21',
  serviceItemIds: ['TSM21']
};

export const paymentRecord1Adt: PaymentRecord = {
  id: 'FPT30',
  flightIds: ['ST2'],
  paymentTransactions: [
    {
      paymentMethod: { paymentType: 'AlternativePaymentMethod'},
      amount: createAmount({
        template: {
          value: 1000,
          currencyCode: 'Eur'
        }
      }),
      authorization: {approvalCode: '831000'}
    }
  ],
  travelerIds: [
    'TRAVELER-0-MOCK'
]
};

export const paymentRecord1Adt2: PaymentRecord = {
  ...paymentRecord1Adt,
  id: 'FPT33',
  travelerIds: [
    'TRAVELER-1-MOCK'
]
};

export const paymentRecord2Adt1StuService1: PaymentRecord = {
  id: 'FPT21',
  paymentTransactions: [
    {
      paymentMethod: { paymentType: 'AlternativePaymentMethod'},
      amount: createAmount({
        template: {
          value: 1000,
          currencyCode: 'Eur'
        }
      }),
      authorization: {approvalCode: '831000'}
    }
  ],
  serviceItemIds: ['TSM21']
};

export const paymentRecord2Adt1StuService2: PaymentRecord = {
  ...paymentRecord2Adt1StuService1,
  id: 'FPT24',
  serviceItemIds: ['TSM24']
};

export const paymentRecord2Adt1StuService3: PaymentRecord = {
  ...paymentRecord2Adt1StuService1,
  id: 'FPT27',
  serviceItemIds: ['TSM27']
};

export const paymentRecord2Adt1StuAdt: PaymentRecord = {
  id: 'FPT40',
  flightIds: ['ST2'],
  paymentTransactions: [
    {
      paymentMethod: { paymentType: 'AlternativePaymentMethod'},
      amount: createAmount({
        template: {
          value: 1000,
          currencyCode: 'Eur'
        }
      }),
      authorization: {approvalCode: '831000'}
    }
  ],
  travelerIds: [
    'TRAVELER-0-MOCK','TRAVELER-1-MOCK'
  ]
};

export const paymentRecord2Adt1StuAdt2: PaymentRecord = {
  ...paymentRecord2Adt1StuAdt,
  id: 'FPT44',
  travelerIds: [
    'TRAVELER-2-MOCK'
  ]
};

export const paymentRecord2Adt1StuService4: PaymentRecord = {
  ...paymentRecord2Adt1StuService1,
  id: 'FPT34',
  insuranceIds: [
    'TSM34'
]
};